import React from 'react';
import Overlay from 'Components/Overlay';
import Input from 'Components/Input';

const remarksConfirmationPopup = (props) => ( 
    <Overlay>
        <div className="bg-light-blue box-shadow ph-20 pv-20 br-5 tCenter">
            <div className="mb-10 tCenter fSemibold fs-20 mt-10 mb-10">
                {props.text || ''} 
            </div>
            <div className='mb-10'>
                <div>
                    <div className="mb-10 tCenter header-medium-color fSemibold fs-14">
                        Enter the Reject Remarks
                    </div>
                    <Input name="remarks" placeholder={'Remarks'} value={props.value} onChange={(e) => props.onChange(e)} />
                </div>
            </div>
            <div className="col-1 ht-60 flex flex-middle flex-center">
                <button className="ht-40 br-5 theme-color border-theme fs-18 fBold wt-150 mr-30" onClick={props.onCancel}>Cancel</button>
                <button className="ht-40 br-5 theme-color border-theme fs-18 fBold wt-150 mr-30" onClick={props.onConfirm}>Confirm</button>
            </div>
        </div>
    </Overlay>
);

export default remarksConfirmationPopup;